
import { Outlet } from 'react-router-dom'
import { Box, useTheme, useMediaQuery } from '@mui/material'
import { useSelector, useDispatch } from 'react-redux'

import { RootState, AppDispatch } from '../../store'
import { setSidebarOpen } from '../../store/slices/uiSlice'
import Header from './Header'
import Sidebar from './Sidebar'
import ToastNotifications from '../common/ToastNotifications'
import { useIssueNotifications } from '../../hooks/useIssueNotifications'

const Layout: React.FC = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const dispatch = useDispatch<AppDispatch>()
  const { sidebarOpen } = useSelector((state: RootState) => state.ui)

  const sidebarWidth = 280

  // Enable real-time notifications
  useIssueNotifications()

  const handleSidebarToggle = () => {
    dispatch(setSidebarOpen(!sidebarOpen))
  }

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      {/* Sidebar - positioned first so it's behind the header */}
      <Sidebar
        open={sidebarOpen}
        onToggle={handleSidebarToggle}
        width={sidebarWidth}
        isMobile={isMobile}
      />

      {/* Main content area */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          // Remove marginLeft - let the sidebar handle its own positioning
        }}
      >
        {/* Header - positioned within the main content area */}
        <Header onSidebarToggle={handleSidebarToggle} />

        {/* Content area - properly positioned below header */}
        <Box
          sx={{
            flexGrow: 1,
            mt: '64px', // Account for fixed header height
            px: 3, // Add horizontal padding
            pb: 3, // Add bottom padding
            pt: 2, // Add top padding
          }}
        >
          <Outlet />
        </Box>
      </Box>
      
      {/* Toast Notifications */}
      <ToastNotifications />
    </Box>
  )
}

export default Layout
